import {
    AppBar,
    Box,
    ClickAwayListener,
    IconButton,
    Menu,
    MenuItem,
    Toolbar,
} from '@mui/material'
import React, { useState } from 'react'
import { isIOS, isTablet } from 'react-device-detect'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import SettingsIcon from '@mui/icons-material/Settings'
import { useHistory } from 'react-router-dom'
import { CFDROUTE } from 'pages/CustomerFacingDisplayPage/CFDLayout'
import { useCFDContext } from 'pages/CustomerFacingDisplayPage/context/useCFDContext'
import cfdToast from '../utils/cfdToast'
import CFDHWAgentStatusIcon from '../hardwareAgent/CFDHWAgentStatusIcon'

const CFDToolbar = () => {
    const [hide, setHide] = useState(false)
    const history = useHistory()
    const { setClientID, onDisconnectedToPOS } = useCFDContext()
    const goToHWAgentSetting = () => {
        onDisconnectedToPOS()
        history.push(CFDROUTE.HW_SETTING)
    }

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    const disconnect = () => {
        setClientID(undefined)
        onDisconnectedToPOS()
        cfdToast.success('Disconnected')
    }

    function toggleFullscreen() {
        if (document.fullscreenElement) {
            document.exitFullscreen()
        } else {
            document.documentElement.requestFullscreen()
        }
    }

    return (
        <React.Fragment>
            <ClickAwayListener
                mouseEvent="onMouseDown"
                touchEvent="onTouchStart"
                onClickAway={() => {
                    setHide((hide) => !hide)
                }}
            >
                <Box
                    sx={{
                        display: hide ? 'none' : 'block',
                        position: 'relative',
                    }}
                >
                    <AppBar position="fixed">
                        <Toolbar>
                            Customer Facing Display
                            <Box sx={{ flexGrow: 1, display: 'flex' }} />
                            <CFDHWAgentStatusIcon />
                            <IconButton
                                size="small"
                                onClick={handleClick}
                                color="inherit"
                                aria-controls={
                                    open ? 'demo-customized-menu' : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                            >
                                <SettingsIcon />
                            </IconButton>
                            <Menu
                                id="demo-customized-menu"
                                MenuListProps={{
                                    'aria-labelledby': 'demo-customized-button',
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={goToHWAgentSetting}>
                                    Setting Hardware agent
                                </MenuItem>
                                <MenuItem onClick={disconnect}>
                                    Disconnect
                                </MenuItem>
                            </Menu>
                            <Box sx={{ display: 'flex' }}>
                                {/* isIPad13 only works with IPad with IOS13, so I guess we better use (isIOS and isTablet) */}
                                {!(isIOS && isTablet) && (
                                    <IconButton
                                        size="small"
                                        aria-label="toggle fullscreen"
                                        color="inherit"
                                        onClick={toggleFullscreen}
                                    >
                                        <FullscreenIcon />
                                    </IconButton>
                                )}
                            </Box>
                        </Toolbar>
                    </AppBar>
                    <Toolbar />
                </Box>
            </ClickAwayListener>
        </React.Fragment>
    )
}

export default CFDToolbar
